var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-tooltip',{attrs:{"content-class":"bg-dark text-white","anchor":"top middle","self":"bottom middle"}},[_c('div',{staticClass:"tooltip-card"},_vm._l((_vm.details),function(detail,index){return _c('div',{key:index},[(detail.length)?_c('div',[_vm._v(_vm._s(detail))]):_c('br')])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }